import * as React from 'react';

export default (props: any) => (
    <svg
        width={200}
        height={200}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        // className="lds-bar-chart"
        // style={{ background: "0 0", overflow: 'hidden' }}
        {...props}
    >
        <g transform="rotate(180 50 50)">
            <rect y="15" height="30.4942" fill="#4285f4" x="15"
                  width="10">
                <animate attributeName="height" calcMode="spline" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1"
                         keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.4s" repeatCount="indefinite"/>
            </rect>
            <rect y="15" height="47.7995" fill="#eeeeee" x="35"
                  width="10">
                <animate attributeName="height" calcMode="spline" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1"
                         keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.2s" repeatCount="indefinite"/>
            </rect>
            <rect y="15" height="47.2575" fill="#4a90e2" x="55"
                  width="10">
                <animate attributeName="height" calcMode="spline" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1"
                         keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="-0.6s" repeatCount="indefinite"/>
            </rect>
            <rect y="15" height="69.827" fill="#787b80" x="75"
                  width="10">
                <animate attributeName="height" calcMode="spline" values="50;70;30;50" keyTimes="0;0.33;0.66;1" dur="1"
                         keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" begin="0s" repeatCount="indefinite"/>
            </rect>
        </g>
    </svg>
)
